window.addEventListener('DOMContentLoaded', (event) => {
	// FAQs on single-advice pages.
	const formButtons = document.querySelectorAll('a[href="#open-form"]');

	if( formButtons.length === 0 ) {
		return;
	}

	const formButton = formButtons[0];

	formButton.addEventListener('click', function (e) {
		e.preventDefault();

		const formContainer = document.querySelectorAll('.contactform-container')[0];

		formContainer.classList.add('open');
		formButton.scrollIntoView({
			behavior: 'smooth',
		});
	});


});
